import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './AnimatedSection';
import { HexShape } from './HexagonLogo';
import { HiMail, HiPhone, HiLocationMarker } from 'react-icons/hi';
import { FaInstagram, FaLinkedinIn, FaWhatsapp, FaFacebookF, FaBehance } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div className="container">
        <FadeIn>
          <div className="grid-footer" style={{ paddingBottom: 48, borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
            <div>
              <div style={styles.logoWrap}>
                <Link to="/">
                  <img src="/logo.png" alt="HTV Digital" style={{ height: '85px', width: 'auto' }} />
                </Link>
              </div>
              <p style={{ color: '#549E84', fontSize: '0.8rem', fontWeight: 500, marginBottom: 8, marginTop: 12 }}>Hive. Thrive. Ventive.</p>
              <p style={{ color: '#555', fontSize: '0.8rem', lineHeight: 1.7, maxWidth: 260, marginBottom: 20 }}>
                The AI engine behind industrial India's digital future.
              </p>
              <div style={{ display: 'flex', gap: 8 }}>
                {[FaInstagram, FaLinkedinIn, FaWhatsapp, FaFacebookF, FaBehance].map((Icon, i) => (
                  <span key={i} style={styles.socialIcon}><Icon size={14} /></span>
                ))}
              </div>
            </div>

            <div style={styles.linkCol}>
              <h4 style={styles.colTitle}>Quick Links</h4>
              {[['/', 'Home'], ['/about', 'About'], ['/services', 'Services'], ['/case-study', 'Case Study'], ['/pricing', 'Pricing'], ['/contact', 'Contact']].map(([path, label]) => (
                <Link key={path} to={path} style={styles.footerLink}>{label}</Link>
              ))}
            </div>

            <div style={styles.linkCol}>
              <h4 style={styles.colTitle}>Services</h4>
              {['AI Video Production', 'Market Research', 'AI Content Creation', 'Web Design & Dev'].map((s, i) => (
                <Link key={i} to="/services" style={styles.footerLink}>{s}</Link>
              ))}
            </div>

            <div style={styles.linkCol}>
              <h4 style={styles.colTitle}>Contact</h4>
              <div style={styles.contactItem}><HiMail size={14} color="#3E7562" /><span>hello@htvdigital.in</span></div>
              <div style={styles.contactItem}><HiPhone size={14} color="#3E7562" /><span>+91 99999 00000</span></div>
              <div style={styles.contactItem}><HiLocationMarker size={14} color="#3E7562" /><span>Hyderabad, Telangana</span></div>
            </div>
          </div>
        </FadeIn>

        <div style={styles.bottom}>
          <p style={styles.copy}>&copy; {new Date().getFullYear()} HTV Digital. All rights reserved.</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <HexShape size={14} color="#3E7562" opacity={0.3} />
            <p style={styles.copy}>Hive &middot; Thrive &middot; Ventive</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

const styles = {
  footer: { background: '#080808', borderTop: '1px solid rgba(255,255,255,0.03)', padding: '80px 0 28px' },
  logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  linkCol: { display: 'flex', flexDirection: 'column', gap: 10 },
  colTitle: { fontSize: '0.75rem', fontWeight: 700, color: '#fff', marginBottom: 4, textTransform: 'uppercase', letterSpacing: 2 },
  footerLink: { color: '#555', fontSize: '0.82rem', transition: '0.3s', textDecoration: 'none' },
  contactItem: { display: 'flex', alignItems: 'center', gap: 10, color: '#555', fontSize: '0.82rem' },
  socialIcon: { width: 32, height: 32, border: '1px solid rgba(62,117,98,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#777', transition: '0.3s', cursor: 'pointer' },
  bottom: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 24, flexWrap: 'wrap', gap: 8 },
  copy: { color: '#444', fontSize: '0.75rem' },
};
